import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

import userPage from 'decorators/userPage';
import notePage from 'decorators/notePage';
import { findUser, saveUserField } from 'actions/users';
import { fetchLeases } from 'actions/leases';
import {
  getUser,
  getLoggedInUser,
  getIncludedInGroups,
  getFilteredSimoSubs,
  getIsAdmin,
} from 'reducers';
import User from 'components/User';
import NoteList from 'components/NoteList/NoteList';
import Pagination from 'components/Pagination/Pagination';
import AttUserSubs from './UserSubs/att';
import SimoUserSubs from './UserSubs/simo';
import QuickUserSubs from './UserSubs/quick';
import GenerateRenewalInvoiceButton from 'components/GenerateRenewalInvoiceButton/GenerateRenewalInvoiceButton';
import UserDeviceContracts from './UserDeviceContracts';
import UserSubsToCsv from '../components/UserSubsToCsv/UserSubsToCsv';
import { fetchUserSubCounts } from 'api';
import { scrollToBlock } from 'helpers/scrolls';
import FormError from 'components/FormError';
import { prettyKey } from 'helpers/formatters';
import UserSimoDevices from 'components/simo/UserSimoDevices';
import { hasComma } from 'helpers/validators';
import { caretUserNavSafariFix, isBusinessChild, isB2b } from 'helpers/user';
import { can, permActions } from 'permissions';
import { BUSINESS_GROUP, RESELLER_GROUP } from 'permissions/userGroups';

export class ViewUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      subsCount: {
        att: {},
        simo: {},
        quick: {},
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    const newUser = this.props.user;
    const oldUser = oldProps.user;
    if (newUser && !oldUser) {
      this.fetchData();
    }

    if (this.props.userId !== oldProps.userId) {
      this.fetchData();
    }
  }

  fetchCreatorUser = () => {
    const { user, loggedInUser, findUser } = this.props;

    if (!user.created_by) return;

    const isBusinessGroup = BUSINESS_GROUP.includes(
      loggedInUser.acl_group_name,
    );
    const isResellerGroup = RESELLER_GROUP.includes(
      loggedInUser.acl_group_name,
    );

    // business can't request admin user data
    if (isBusinessGroup && BUSINESS_GROUP.includes(user.acl_group_name)) {
      return;
    }

    // reseller can't request admin user data
    if (isResellerGroup && RESELLER_GROUP.includes(user.acl_group_name)) {
      return;
    }

    findUser(user.created_by);
  };

  fetchData = () => {
    const { user } = this.props;

    if (user) {
      this.fetchCreatorUser();
      fetchUserSubCounts(user.id)
        .then((res) => {
          this.setState({ subsCount: res.data });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  handleUpdateField = (name, value) => {
    const { saveUserField, user } = this.props;

    if (
      ['first_name', 'last_name', 'company_name'].includes(name) &&
      hasComma(value)
    ) {
      toast.error(`${prettyKey(name)}: comma sign is not allowed`);
      return;
    }

    // const values = {
    //   id: user.id,
    //   first_name: user.first_name,
    //   last_name: user.last_name,
    //   phone_number: user.phone_number,
    //   company_name: user.company_name,
    // };
    // if (!(isReseller || isBusiness)) {
    //   values.email = user.email;
    // }

    this.setState({ loading: true });
    saveUserField({ id: user.id, [name]: value })
      .then(() => {
        toast.success(`${prettyKey(name)} updated`);
        this.setState({ loading: false });
        if (['first_name', 'last_name'].includes(name)) {
          caretUserNavSafariFix();
        }
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        this.setState({ loading: false });
      });
  };

  handleScroll = (e, blockId) => {
    e.preventDefault();
    scrollToBlock(`#${blockId}`);
  };

  goToUserCustomPlans = () => {
    const { userId, history } = this.props;
    history.push(`/custom-plan-prices?user_profile=${userId}`);
  };

  render() {
    const {
      user,
      userId,
      simoSubs,
      notes,
      notesFirstPageAlways,
      updateNote,
      createNote,
      fetchNotes,
      notFound,
      pageCount,
      page,
      hasSimoSubs,
      creatorUser,
      loggedInUser,
      isReseller,
      isBusiness,
      isAdminLoggedIn,
    } = this.props;

    const { subsCount, loading } = this.state;
    if (notFound) {
      return <div>Not Found</div>;
    }
    if (!user) {
      return <div>Loading...</div>;
    }

    const isB2bLoggedIn = isReseller || isBusiness;
    const isUserB2b = isB2b(user);
    const showAddChildBtn = Boolean(isUserB2b && isAdminLoggedIn);
    const showGenerateRenewalInvoiceButton =
      can(loggedInUser, permActions.CREATE_RENEWAL_INVOICE) &&
      !isBusinessChild(user);
    const showUserCustomPlans =
      can(loggedInUser, permActions.VIEW_CUSTOM_PLAN_PRICING) &&
      !isBusinessChild(user);
    const isBusinessChildUser = isBusinessChild(user);
    const showAttUserSubs = !isBusinessChildUser;
    const showQuickUserSubs = !isBusinessChildUser;
    const showSimoUserSubs = !isBusinessChildUser;
    const showSimoUserDevices = !isBusinessChildUser;
    const showUserDeviceContracts = !isBusinessChildUser;
    const showSubsToCsv = !isBusinessChildUser;
    const canEditProfile = can(loggedInUser, permActions.EDIT_USER_PROFILE, {
      user,
      loggedInUser,
    });
    return (
      <div>
        <div className="d-flex" style={{ alignItems: 'flex-end' }}>
          <div>
            {showGenerateRenewalInvoiceButton && (
              <GenerateRenewalInvoiceButton
                userId={userId}
                onComplete={(success) => (
                  <Redirect to={`/purchases/${success}/view`} />
                )}
              />
            )}
            {simoSubs && simoSubs.length && showGenerateRenewalInvoiceButton ? (
              <div className="mar-t">
                <Link
                  to={`/simo/subscriptions/activation-renewal?user_profile=${userId}`}
                >
                  <button className="btn btn-primary">
                    Generate Simo Activation Renewal Invoice
                  </button>
                </Link>
              </div>
            ) : null}
            {showUserCustomPlans && (
              <Button
                bsStyle="default"
                className="mar-t"
                onClick={this.goToUserCustomPlans}
              >
                View User Custom Plans
              </Button>
            )}
            {showAddChildBtn && (
              <Link
                to={`/users/${userId}/create-child`}
                className="mar-l mar-t btn btn-primary"
              >
                Add child user
              </Link>
            )}
          </div>
        </div>
        <br />
        <User
          user={user}
          isB2bLoggedIn={isB2bLoggedIn}
          hasSimoSubs={hasSimoSubs}
          creatorUser={creatorUser}
          subsCount={subsCount}
          scrollToBlock={this.handleScroll}
          loading={loading}
          handleUpdateField={this.handleUpdateField}
          canEditProfile={canEditProfile}
        />
        {showAttUserSubs && (
          <AttUserSubs user={user} userId={userId} subsCount={subsCount.att} />
        )}

        {showQuickUserSubs && (
          <QuickUserSubs
            user={user}
            userId={userId}
            subsCount={subsCount.quick}
          />
        )}
        {showSimoUserSubs && (
          <SimoUserSubs
            user={user}
            userId={userId}
            subsCount={subsCount.simo}
          />
        )}
        {showSimoUserDevices && <UserSimoDevices user={user} userId={userId} />}
        {/* <UserSubs userId={userId} />
        <TracfoneUserSubs userId={userId} /> */}

        {showSubsToCsv && (
          <UserSubsToCsv userId={userId} loggedInUser={loggedInUser} />
        )}
        {showUserDeviceContracts && <UserDeviceContracts userId={userId} />}
        <NoteList
          userId={userId}
          notes={notes}
          updateNote={updateNote}
          notesFirstPageAlways={notesFirstPageAlways}
          createNote={createNote}
          fetchNotes={fetchNotes}
          showPinNote
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/users/${userId}/view?page=${pageNum}`}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const createdBy = ownProps.user && ownProps.user.created_by;
  const simoSubs = getFilteredSimoSubs(state, 'all', '1');
  return {
    hasSimoSubs: Boolean(simoSubs && simoSubs.length),
    creatorUser: createdBy && getUser(state, createdBy),
    loggedInUser: getLoggedInUser(state),
    isReseller: getIncludedInGroups(state, ['RESELLER']),
    isBusiness: getIncludedInGroups(state, ['BUSINESS']),
    isAdminLoggedIn: getIsAdmin(state),
    hideSimo: getIncludedInGroups(state, ['BUSINESS_ADMIN', 'BUSINESS_AGENT']),
    simoSubs,
  };
};

const mapDispatchToProps = {
  findUser,
  fetchLeases,
  saveUserField,
};

export const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewUser);

export default compose(
  userPage,
  notePage,
)(connect(mapStateToProps, mapDispatchToProps)(ViewUser));
